import Layout from "@/pages/views/admin/Layout.vue"

export default [
  {
    path: '/admin',
    name: 'AdminLayout',
    component: Layout
  }
]